export const isAmenitiesAndSettings = (name) => {
  return name === 'Amenities and Settings'
}
